/*
 * File: RelatedModule.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on July 21, 2025 at 1:28 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: July 21, 2025 at 1:30 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { Card } from '../../Card';
import { ClampContent } from '../../ClampContent';


/**
 * Styles
 */

export const RelatedCard = styled(Card)`
	border-radius: 10px;
	padding: 10px;
`;

export const RelatedFlexCard = styled(RelatedCard)`
	display: flex;
	align-items: center;
`;

export const RelatedClampContent = styled(ClampContent)`
	flex-grow: 1;
`;
